var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { commonCssStyles } from "../../global-styles.js";
import { ifDefined } from "lit/directives/if-defined.js";
let FooterContactLink = class FooterContactLink extends LitElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
    }
    render() {
        return html `
      <a
        class="container ${classMap({ disabled: this.disabled })}"
        type="button"
        href="${this.href ? this.href : "javascript:;"}"
        target="${ifDefined(this.target)}"
      >
        <div class="icon">
          <slot name="icon"></slot>
        </div>
        <div class="text-section">
          <div class="label text-base-semibold" part="labellext">
            <span>${this.text}</span>
          </div>
          <div class="rule" part="labelrule"></div>
        </div>
      </a>
    `;
    }
};
// noinspection CssUnresolvedCustomProperty,CssNoGenericFontName
FooterContactLink.styles = [
    commonCssStyles,
    css `
      .container {
        background-color: transparent;
        margin: 0;
        padding: 0;
        text-align: inherit;
        font: inherit;
        display: inline-flex;
        align-items: center;
        gap: var(--spacing-xs);
        text-decoration: none;
        cursor: default;
        outline-color: transparent;
        max-height: 24px;
        box-sizing: border-box;
      }

      .container .text-section {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
      }

      .container .label {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: var(--tones-lavender50-color);
        text-align: center;
        white-space: nowrap;
      }

      .container .label span {
        line-height: 24px;
      }

      .container .rule {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        height: 1px;
        background: var(--tones-lavender60-color);
        width: 0;
      }

      .container .icon {
        fill: var(--tones-lavender50-color);
        width: 16px;
        height: 16px;
      }

      .container * {
        transition: var(--delay-transition75);
      }

      .container:hover {
        cursor: pointer;
      }

      .container:hover .label {
        color: var(--tones-lavender60-color);
      }

      .container:hover .rule {
        width: 100%;
      }

      .container:hover .icon {
        fill: var(--tones-lavender60-color);
      }

      .container:active .label {
        color: var(--tones-lavender70-color);
      }

      .container:active .rule {
        width: 100%;
        background-color: var(--tones-lavender70-color);
      }

      .container:active .icon {
        fill: var(--tones-lavender70-color);
      }

      .container.disabled {
        pointer-events: none;
      }

      .container.disabled .label {
        color: var(--tones-lavender60-disabled-color);
      }

      .container.disabled .rule {
        width: 0;
      }

      .container.disabled .icon {
        fill: var(--tones-lavender60-disabled-color);
      }

      .container:focus-visible {
        outline: 2px solid var(--tones-lavender50-color);
        border-radius: 4px;
      }
    `,
];
__decorate([
    property()
], FooterContactLink.prototype, "text", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], FooterContactLink.prototype, "disabled", void 0);
__decorate([
    property()
], FooterContactLink.prototype, "href", void 0);
__decorate([
    property()
], FooterContactLink.prototype, "target", void 0);
FooterContactLink = __decorate([
    customElement("footer-contact-link")
], FooterContactLink);
export { FooterContactLink };
